import React from 'react';
import { OverlayComponent, SpinLoader } from 'app/components';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { IndicatorFactorsListItems } from 'app/area/indicator-factors/list/list-items/indicator-factors-list-items';
import { IndicatorFactorsListHeader } from 'app/area/indicator-factors/list/list-items/indicator-factors-header';
import { CodetableListComponentProps } from 'app/area/indicator-factors/types';

export const IndicatorFactorsListComponent: React.FC<CodetableListComponentProps> = (props) => {
  const {
    shouldRenderList, shouldRenderSpinLoader, hasCategoryMetadata, hasSelectedCategory,
    fetchingData, data, numberOfResults, modifiedItems, updating, validation, translation,
    codetableAccess, itemAccesses, saveChanges, cancelChanges } = props;

  return <>
    <OverlayComponent
      displayOverlay={updating}
      overlayText={translation.saving_factors} />
    <SearchFilters {...props}>
      {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
        && <IndicatorFactorsListHeader
          fetchingData={fetchingData}
          data={data}
          numberOfResults={numberOfResults}
          modifiedItems={modifiedItems}
          saveChanges={saveChanges}
          cancelChanges={cancelChanges}
          codetableAccess={codetableAccess}
          itemAccesses={itemAccesses}
          validation={validation}
          translation={translation} />}

      {shouldRenderSpinLoader ? <SpinLoader /> : undefined}

      {shouldRenderList && <IndicatorFactorsListItems {...props} />}
    </SearchFilters>
  </>;
};
